import { BaseQueryFn, FetchArgs, createApi } from '@reduxjs/toolkit/query/react';
import { eApiTags } from '../eApiTags';

export const getLocalStorage = ({ url }: { url: string }) => {
  const stringData = localStorage.getItem(url);
  const value = (stringData && JSON.parse(stringData)) ?? undefined;
  return { data: { value } };
};

export const putLocalStorage = ({ url, value }: { url: string; value: any }) => {
  if (value === null || value === undefined) {
    localStorage.removeItem(url);
  } else {
    const stringData = JSON.stringify(value);
    localStorage.setItem(url, stringData);
  }
  return { data: { value } };
};

const localStorageBaseQuery: BaseQueryFn<FetchArgs, { value: any }, { message: string }> = ({ url, method, body }) => {
  switch (method) {
    case 'GET':
      return getLocalStorage({ url });
    case 'PUT':
      return putLocalStorage({ url, value: body });
  }
  return { error: { message: 'Unsupported Method, use get or put with local storage apis.' } };
};

export const BaseLocalStorageApi = createApi({
  reducerPath: 'localStorageApi',
  baseQuery: localStorageBaseQuery,
  tagTypes: Object.values(eApiTags),
  endpoints: () => ({}),
});
